export let defaultPackageLabels = [
  {
    label: '套餐名称',
    value: 'name'
  },
  {
    label: '实验室检测平台',
    value: 'productBean.name'
  },
  {
    label: '检测项个数',
    value: 'detectionItemCount'
  }
]
export let packageType = [
  {
    label: '基础套餐',
    value: 'DEFAULT_WHOLE_GENOM'
  },
  {
    label: '非基础套餐',
    value: 'CUSTOMER'
  }
]
